import { DateTimePicker, type DateTimePickerProps } from '@platform/ui';
import { useContext } from 'react';
import { CalendarContext } from './calendar/calendar-context';

/** Account week hints only: values, callbacks and date/DST conversion remain with their existing callers. */
export function AccountDateTimePicker(props: DateTimePickerProps) {
  const settings = useContext(CalendarContext)?.settings;
  return <DateTimePicker {...props}
    weekNumbering={props.weekNumbering ?? settings?.weekNumbering ?? 'regional'}
    weekTimeZone={props.weekTimeZone ?? settings?.displayTimeZone ?? Intl.DateTimeFormat().resolvedOptions().timeZone}
  />;
}
